{
  "zh-CN": {
    "baseSelect": {
      "actions": {
        "fetchMore": "加载更多"
      },
      "labels": {
        "search": "输入以搜索",
        "nullablePrompt": "未选择选项",
        "prompt": "Please select an Option",
        "removeTooltip": "点击移除选项"
      },
      "model": {
        "baseModel": {
          "label": "基础型号"
        }
      },
      "modelLoaner": {
        "loanerModel": {
          "label": "借用型号"
        }
      },
      "modelSnubCraft": {
        "snubCraft": {
          "label": "舰载小艇",
          "prompt": "选择舰载小艇"
        }
      },
      "modelPosition": {
        "positionType": {
          "label": "岗位类型",
          "prompt": "选择岗位类型"
        },
        "source": {
          "label": "来源",
          "prompt": "选择来源"
        }
      },
      "fleet": {
        "members": {
          "shipsFilter": {
            "label": "飞船筛选",
            "prompt": "选择要显示的飞船",
            "nullablePrompt": "选择一个选项"
          },
          "blueprintsFilter": {
            "label": "蓝图筛选",
            "prompt": "选择要共享的蓝图",
            "nullablePrompt": "请选择一个选项"
          },
          "hangarGroupId": {
            "label": "机库群组",
            "prompt": "选择机库群组",
            "nullablePrompt": "选择群组"
          }
        }
      }
    }
  }
}
